import { createReducer } from 'redux-act';
import {requestDashboardData, responseDashboardData} from './action';


const defaultState = {
	requestProcess: false,
};

const reducer = createReducer({

	[requestDashboardData]: (state) => {
    return {
      requestProcess: true,
	  	data: [],
    };
  },

  [responseDashboardData]: (state, params) => {
		return {
			requestProcess: false,
			data: params,
		};
	},


}, defaultState);



export default reducer
